const workTimeOptions = [
  { name: "Keine Angabe", value: "undefined" },
  { name: "Vollzeit", value: "fulltime" },
  { name: "Teilzeit", value: "parttime" },
  { name: "Mini Job", value: "mini" },
];

export default workTimeOptions;
